import { Pressable, Modal as RNModal, StyleSheet, View } from 'react-native';
import { ThemedShared, ThemedValues } from 'styles/themed';
import { topNavigationProps } from "styles/top-navigation";
import { IconSystemConstants } from 'utils/constants/IconNameConstants';
import Icon from 'components/atoms/Icon'

const Modal = ({ visible = true, onClose, modalStyle, headerStyle, closeStyle, backdropStyle, children }) =>{

    return (
        <RNModal
            animationType="fade"
            transparent={ true }
            visible={ visible }
            onRequestClose={() => {
            }}>

            <View 
                style={[ styles.centeredView, backdropStyle ]}>
                
                <View 
                    style={[ styles.modalView, modalStyle ]}>

                    {/* Header */}
                    <View 
                        style={[ styles.headerContainer, headerStyle ]}>
                        
                        {/* Close button */}
                        { onClose && (
                            <View
                                style={ styles.closeContainer }>
                                
                                <Pressable
                                    onPress={ onClose }>

                                    <Icon 
                                        icon={ IconSystemConstants.CLOSE } 
                                        { ...topNavigationProps.icon } 
                                        style={[
                                            closeStyle 
                                        ]}
                                    />
                                </Pressable>
                            </View>
                        )}
                    </View>

                    {/* Content */}
                    { children }
                </View>
            </View>
        </RNModal>
    );
}

const styles = StyleSheet.create({
    headerContainer: {
        width: '100%',
        alignSelf: 'flex-end',
    },
    closeContainer: {
        // position: 'absolute',
        padding: 8,
        alignSelf: 'flex-end',
		justifyContent: 'flex-end',
    },

    centeredView: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    modalView: {
        // width: '600px',
        backgroundColor: 'white',
        borderRadius: ThemedValues.borderRadius,
        alignItems: 'center',
        ...ThemedShared.shadowed,
        overflow: 'hidden',
    },
})

export default Modal